<template>
    <div class="services-editor">
      <h3>Éditeur de Services</h3>
  
      <div v-for="(service, index) in localServices" :key="index" class="service-item">
        <div class="form-group">
          <label :for="'name-' + index">Nom du Service</label>
          <input
            v-model="service.name"
            :id="'name-' + index"
            type="text"
            placeholder="Entrez le nom du service"
          />
        </div>
        <div class="form-group">
          <label :for="'description-' + index">Description</label>
          <textarea
            v-model="service.description"
            :id="'description-' + index"
            placeholder="Entrez une description"
          ></textarea>
        </div>
        <div class="form-group">
          <label :for="'icon-' + index">Icône (URL)</label>
          <input
            v-model="service.icon"
            :id="'icon-' + index"
            type="text"
            placeholder="Entrez l'URL de l'icône"
          />
        </div>
        <button @click="removeService(index)" class="btn-remove">Supprimer le Service</button>
      </div>
  
      <button @click="addService" class="btn-add">Ajouter un Service</button>
  
      <div class="form-actions">
        <button @click="saveChanges" class="btn-save">Enregistrer</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "ServicesEditor",
    props: {
      servicesData: {
        type: Array,
        required: false, // Make it optional
        default: () => [] // Default to empty array if not provided
      },
    },
    data() {
      return {
        localServices: this.servicesData && this.servicesData.length ? [...this.servicesData] : [] // Initialize based on servicesData or empty array
      };
    },
    methods: {
      addService() {
        this.localServices.push({
          name: "",
          description: "",
          icon: "",
        });
      },
      removeService(index) {
        this.localServices.splice(index, 1);
      },
      saveChanges() {
        // Emit the updated services back to the parent
        this.$emit("update-services", this.localServices);
      },
    },
    watch: {
      servicesData: {
        handler(newServices) {
          if (newServices && newServices.length) {
            this.localServices = [...newServices];
          }
        },
        immediate: true,
      },
    },
  };
  </script>
  
  <style scoped>
  .services-editor {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .services-editor h3 {
    margin-bottom: 20px;
    font-size: 1.5rem;
    color: #333;
  }
  
  .service-item {
    margin-bottom: 20px;
    border: 1px solid #ccc;
    padding: 15px;
    border-radius: 8px;
    background-color: #fff;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  input,
  textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    font-size: 1rem;
  }
  
  textarea {
    height: 100px;
    resize: none;
  }
  
  button {
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
  }
  
  .btn-add {
    background-color: #28a745;
    color: white;
    margin-top: 10px;
    transition: background-color 0.3s;
  }
  
  .btn-remove {
    background-color: #dc3545;
    color: white;
    margin-top: 10px;
    transition: background-color 0.3s;
  }
  
  .btn-save {
    background-color: #007bff;
    color: white;
    margin-top: 20px;
    transition: background-color 0.3s;
  }
  
  button:hover {
    opacity: 0.9;
  }
  </style>
  